import React, { useEffect, useState } from "react";
import PermissionButton from "../../shared/PermissionButton";
import { useSubjects } from "../../../hooks/useSubjects";
import { Spinner } from "reactstrap";
import Button from "../../shared/Button";
import CustomModal from "../../shared/CustomModal";
import SubjectForm from "./SubjectForm";
import AssignTeacher from "./AssignTeacher";
import SubjectSettings from "./SubjectSettings";
import { checkRolePermissions } from "../../../../../utils/Constants";
import { Tooltip } from "@mui/material";

const ListSubject = ({ name }) => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [assignTeacherModal, setAssignTeacherModal] = useState(false);
  const [subjectSettingsModal, setSubjectSettingsModal] = useState(false);
  const [permissions, setPermissions] = useState({
    permissionEditSubject: false,
    permissionDeleteSubject: false,
    permissionSettingSubject: false,
    permissionAssignTeacher: false,
  });

  const { subjects, deleteSubject, updateSubject, loading, refetchSubjects } =
    useSubjects();

  const checkPermissons = () => {
    setPermissions({
      permissionEditSubject: checkRolePermissions(
        "edit-subject",
        "activity",
        name,
      ),
      permissionDeleteSubject: checkRolePermissions(
        "delete-subject",
        "activity",
        name,
      ),
      permissionSettingSubject: checkRolePermissions(
        "setting-subject",
        "activity",
        name,
      ),
      permissionAssignTeacher: checkRolePermissions(
        "assign-teacher-subject",
        "activity",
        name,
      ),
    });
  };

  useEffect(() => {
    checkPermissons();
  }, []);

  return (
    <>
      <div className="arr-content">
        <div className="arr-heading">
          <h1>List Subject</h1>
          <div className="arr-btns-group">
            <PermissionButton
              moduleName={"Subjects Setup"}
              widgetName={name}
              header={"List Subject"}
              activityName={"select-subject"}
            />
          </div>
        </div>
        <div className="arr-table-container">
          <table aria-label="subject-table" className="arr-table">
            <thead>
              <tr>
                <th>Subject Name</th>
                <th>Subject Code</th>
                <th>Subject Type</th>
                <th>Subject Area</th>
                <th>Description</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading.read ? (
                <tr>
                  <td colSpan={6}>
                    <div className="arr-spinner">
                      <div className="loader">
                        <Spinner size={"md"} color="primary"></Spinner>
                      </div>
                      <div style={{ fontSize: "13px", marginTop: "15px" }}>
                        Please wait !! Processing.....
                      </div>
                    </div>
                  </td>
                </tr>
              ) : subjects.length > 0 ? (
                subjects?.map((subject, idx) => (
                  <tr key={subject.id}>
                    <td>{subject.name}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        {subject.hasTheory && subject.subjectTheoryCode && (
                          <div className="arr-badge">
                            Theory: {subject.subjectTheoryCode}
                          </div>
                        )}
                        {subject.hasPractical &&
                          subject.subjectPracticalCode && (
                            <div className="arr-badge">
                              Practical: {subject.subjectPracticalCode}
                            </div>
                          )}

                        {!subject.subjectTheoryCode &&
                          !subject.subjectPracticalCode &&
                          "N/A"}
                      </div>
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "4px",
                        }}
                      >
                        {subject.hasTheory && (
                          <div className="arr-badge">Theory</div>
                        )}
                        {subject.hasPractical && (
                          <div className="arr-badge">Practical</div>
                        )}
                      </div>
                    </td>
                    <td>{subject.subjectAreaName || "N/A"}</td>
                    <td>{subject.description || "N/A"}</td>
                    <td>
                      <div className="action-btns">
                        {permissions.permissionEditSubject && (
                          <Button
                            size={"sm"}
                            variant={"outline"}
                            onClick={() => {
                              setUpdateModal((prev) => !prev);
                              setSelectedSubject(subject);
                            }}
                          >
                            Update
                          </Button>
                        )}
                        {permissions.permissionAssignTeacher && (
                          <Button
                            size={"sm"}
                            variant={"outline"}
                            onClick={() => {
                              setAssignTeacherModal((prev) => !prev);
                              setSelectedSubject(subject);
                            }}
                          >
                            Assign Teacher
                          </Button>
                        )}
                        {permissions.permissionSettingSubject && (
                          <Button
                            size={"sm"}
                            variant={"outline"}
                            onClick={() => {
                              setSubjectSettingsModal((prev) => !prev);
                              setSelectedSubject(subject);
                            }}
                          >
                            Settings
                          </Button>
                        )}
                        {permissions.permissionDeleteSubject && (
                          <Tooltip
                            title={
                              !subject?.canModify
                                ? "This subject is configured in the assessment and therefore cannot be deleted."
                                : ""
                            }
                          >
                            <div>
                              <Button
                                onClick={() => {
                                  setDeleteModal((prev) => !prev);
                                  setSelectedSubject(subject);
                                }}
                                disabled={!subject?.canModify}
                                size={"sm"}
                                variant={"danger"}
                              >
                                Delete
                              </Button>
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* delete modal */}
      <CustomModal
        isOpen={deleteModal}
        toggle={() => setDeleteModal((prev) => !prev)}
        modalHeader={"Are you sure?"}
        children={
          <div>
            <p>Once Deleted, you will not be able to recover this record</p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
                gap: "8px",
              }}
            >
              <Button
                variant="outline"
                onClick={() => setDeleteModal((prev) => !prev)}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                disabled={loading.delete}
                ariaLabel="delete-subject"
                onClick={() => {
                  deleteSubject(selectedSubject?.id);
                  setDeleteModal(false);
                }}
              >
                {loading.delete ? (
                  <Spinner size={"sm"} color="white" />
                ) : (
                  "Delete"
                )}
              </Button>
            </div>
          </div>
        }
      />

      {/* update modal */}
      <CustomModal
        isOpen={updateModal}
        toggle={() => setUpdateModal((prev) => !prev)}
        modalHeader={"Update Subject"}
        children={
          <SubjectForm
            setUpdateModal={() => setUpdateModal((prev) => !prev)}
            subject={selectedSubject}
            type={"edit"}
            updateSubject={updateSubject}
            isUpdating={loading.update}
          />
        }
      />

      {/* assign teacher modal */}
      <CustomModal
        isOpen={assignTeacherModal}
        toggle={() => setAssignTeacherModal((prev) => !prev)}
        modalHeader={"Assign Teacher"}
        size="md"
        children={
          <AssignTeacher
            subject={selectedSubject}
            closeModal={() => setAssignTeacherModal(false)}
          />
        }
      />

      {/* Subject settings modal */}
      <CustomModal
        isOpen={subjectSettingsModal}
        toggle={() => setSubjectSettingsModal((prev) => !prev)}
        modalHeader={`Subject Settings - ${selectedSubject?.name}`}
        size="lg"
        children={
          <SubjectSettings
            closeModal={() => setSubjectSettingsModal(false)}
            subject={selectedSubject}
            refetchSubjects={refetchSubjects}
          />
        }
      />
    </>
  );
};

export default ListSubject;
